import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-monitoreo-heatmap',
  templateUrl: './monitoreo-heatmap.component.html',
  styleUrls: ['./monitoreo-heatmap.component.scss']
})
export class MonitoreoHeatmapComponent {

  @Input() title: string = '';
  @Input() loading: boolean = false;
  @Input() mapData: any = {};
  @Input() filtroAmPm: string = '';
  @Input() horasColumnas: number[] = [];
  @Input() diasSemana: string[] = [];

  @Output() filtroAmPmChange = new EventEmitter<string>();

  onFiltroChange() {
    this.filtroAmPmChange.emit(this.filtroAmPm);
  }

  getHeatmapValue(dia: string, hora: number): number {
    return this.mapData[`${dia}_${hora}`] || 0;
  }

  getHeatmapRowTotal(dia: string): number {
    let total = 0;
    for (const h of this.horasColumnas) {
      total += this.getHeatmapValue(dia, h);
    }
    return total;
  }

  getHeatmapColTotal(hora: number): number {
    let total = 0;
    for (const d of this.diasSemana) {
      total += this.getHeatmapValue(d, hora);
    }
    return total;
  }

  getHeatmapGrandTotal(): number {
    let total = 0;
    for (const d of this.diasSemana) {
      for (const h of this.horasColumnas) {
        total += this.getHeatmapValue(d, h);
      }
    }
    return total;
  }

  getHeatmapCellClass(value: number): string {
    if (!value || value === 0) return '';
    let max = 0;
    for (const key in this.mapData) {
      if (this.mapData[key] > max) max = this.mapData[key];
    }
    if (max === 0) return '';
    const ratio = value / max;
    if (ratio >= 0.75) return 'heat-high';
    if (ratio >= 0.4) return 'heat-medium';
    return 'heat-low';
  }
}
